"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "HOW DO I BOOK THE TRUCK FOR AN EVENT?",
  answer: "Booking is simple! Head over to our 'Book the Truck' page and fill out the form with your event details. We'll get back to you within 24 hours to confirm availability and discuss your custom taco menu."
}, {
  question: "WHAT IS YOUR MINIMUM ORDER FOR CATERING?",
  answer: "For private events, we typically require a minimum of 50 guests. However, we offer flexible packages for smaller gatherings. Contact our team to find a solution that fits your specific needs."
}, {
  question: "DO YOU OFFER VEGAN OR GLUTEN-FREE OPTIONS?",
  answer: "Absolutely! We pride ourselves on inclusivity. We offer delicious jackfruit carnitas and all our corn tortillas are naturally gluten-free. Just let us know about any allergies during the booking process."
}, {
  question: "HOW FAR DOES THE ROLLING TACOS TRUCK TRAVEL?",
  answer: "We generally serve the greater metropolitan area and up to 50 miles from our home base. For events further away, a small travel fee may apply to keep our wheels rolling to you."
}, {
  question: "CAN WE CUSTOMIZE THE TACO MENU?",
  answer: "Yes! While we have our fan-favorite signatures, we love collaborating on custom menus. From spicy habanero salsas to unique fusion fillings, we can tailor the experience to your event's vibe."
}];
export default function CateringFaq() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="245069" id="catering-faq" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        {}
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold text-foreground font-default mb-4 tracking-tighter uppercase">
            Catering FAQ
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default tracking-wide">
            Everything you need to know about bringing the Rolling Tacos experience to your next big event or private party.
          </p>
        </div>

        {}
        <div ref={accordionRef} className={`bg-card rounded-md shadow-xl border-2 border-primary p-4 md:p-8 transition-all duration-700 delay-100 ease-out ${isAccordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-border/20 py-2">
                <AccordionTrigger className="text-foreground font-bold text-left text-lg md:text-xl hover:no-underline hover:text-primary transition-colors font-default tracking-tight uppercase group">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-primary text-base md:text-lg leading-relaxed font-default pt-2 pb-4 pr-8">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {}
        <div ref={ctaRef} className={`mt-12 md:mt-16 text-center transition-all duration-700 delay-200 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex flex-col items-center justify-center p-6 md:p-8 bg-card/50 backdrop-blur-md rounded-md border-2 border-primary shadow-2xl w-full max-w-md mx-auto">
            <h3 className="text-2xl font-bold text-foreground font-default mb-2 uppercase tracking-tight">
              Still Hungry for Info?
            </h3>
            <p className="text-muted-foreground mb-6 font-default text-center tracking-wide">
              Our street food experts are standing by to help you plan the perfect taco takeover.
            </p>
            <Button asChild size="lg" className="w-full sm:w-auto rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-widest">
              <Link to="/TruckBookingPage">
                <MessageCircle className="mr-2 size-5" />
                Get in Touch
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}